<template>
  <form ref="formForgotPassword" class="login__form form--custom" novalidate @submit.prevent="handleForgotPassword">
    <h2 class="login__title">{{ $t(`${namespace}.recoverPassword`) }}</h2>
    <p class="login__text">{{ $t(`${namespace}.forgotPasswordMsg`) }}</p>

    <label for="">{{ $t(`${namespace}.corporateEmail`) }}</label>
    <v-text-field
      v-model="recoveryEmail"
      type="text"
      name="email"
      :placeholder="$t(`${namespace}.loginEmailPlaceholder`)"
      :disabled="submitted"
      v-validate="{ required: true, email: true }"
      :error-messages="errors.collect($t(`${namespace}.corporateEmailName`))"
      :data-vv-name="$t(`${namespace}.corporateEmailName`)"
      required
      flat
      outline
      solo
    />

    <v-layout align-center justify-center row fill-height>
      <v-flex xs-6>
        <a href="#" class="text--link accent--text" @click.prevent="toggleForm">
          {{ $t(`${namespace}.iRememberedMyPassword`) }}
        </a>
      </v-flex>

      <v-flex xs-6>
        <v-btn
          type="submit"
          color="warning--gradient"
          :disabled="submitted"
          :loading="submitted"
          round
          block
          depressed
          large
        >
          {{ $t(`${namespace}.sendEmail`) }}
        </v-btn>
      </v-flex>
    </v-layout>
  </form>
</template>

<script>
import { mapActions } from 'vuex'
import userService from '@/services/user'

export default {
  name: 'ForgotPasswordForm',
  data () {
    return {
      namespace: 'Views.LoginPage',
      recoveryEmail: null,
      submitted: false
    }
  },
  methods: {
    ...mapActions({
      successAlert: 'snackbarAlert/success',
      errorAlert: 'snackbarAlert/error'
    }),

    toggleForm () {
      this.$emit('toggleForm')
    },

    async handleForgotPassword () {
      const isValid = await this.$validator.validateAll()
      if (!isValid) return

      this.submitted = true

      try {
        const { data: res } = await userService.forgotPassword(this.recoveryEmail)

        if (!res.valid) {
          this.errorAlert(res.message)
          this.recoveryEmail = null
        } else {
          this.successAlert(this.$t(`${this.namespace}.sendEmailSuccess`))
          this.toggleForm()
        }
      } catch (err) {
        console.log('Error', err)
        this.errorAlert(this.$t('Common.genericError'))
      }

      this.submitted = false
    }
  }
}
</script>
